export default "__VITE_ASSET__Xzm5Quy___"